<template>
  <div class="row justify-content-center email-validation-form" v-if="cargado">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div class="text-center">
            <div class="row">
              <div class="col-md-12">
                <img src="@/assets/verifymail.png" class="img-fluid mb-2" style="max-width:160px;" />
              </div>
            </div>
            <h3 class>Necesitamos validar tu e-mail</h3>
            <div class="row">
              <div class="col-md-12 text-center">
                <span>Para tu seguridad, necesitamos validar tu e-mail. Te enviamos un correo a tu casilla a fin de poder validar la misma. Seguí las instrucciones y confirmaremos tu dirección.</span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12">
                <base-input
                  addon-left-icon="ni ni-email-83"
                  placeholder="Email"
                  class="input-group-alternative mb-3"
                  v-model="model.email"
                  disabled
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="text-center col-md-12">
                <button @click="validateAccountMail" class="btn btn-danger btn-lg">Reenviar correo</button>
              </div>
            </div>
            <div class="row">
              <div class="text-center col-md-12 mt-2">
                <button @click="hasAccountMailValidated" class="btn btn-danger btn-lg">Ya lo validé</button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="text-center col-md-12 mt-4">
                <b-button @click="logout()" class="btn-cerrar-sesion">Cerrar sesión</b-button>
              </div>
            </div>
          </div>

          <!-- <div class="text-center" v-else>
                        <img src="@/assets/mail_verify.png" class="img-fluid" />
                        <h3 class="rscolor">¡ Tu e-mail fue verificado correctamente !</h3>Ya podés utilizar esta dirección de correo electrónico para realizar gestiones y recibir notificaciones
                        <div>
                            <a
                                href="http://resimple.com.ar/dashboard"
                                class="btn active btnVerify"
                                role="button"
                                aria-pressed="true"
                                >Ir a resimple.com.ar</a>
                        </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  name: "EmailValidationForm",
  data() {
    return {
      model: {
        email: ""
      },
      isMailValidated: false,
      cargado: false,
      ShouldPerformTwoStepVerification: false
    };
  },
  methods: {
    logout() {
      let context = this;

      axiosHelpers.axiosPost("Account/Logout", {}, this, function(data) {
        if (data.ResponseVM != null) {
          context.$store.dispatch("logout").then(() => {
            context.$router.push("login");
          });
        }
      });
    },
    hasAccountMailValidated() {
      let context = this;

      axiosHelpers.axiosPost(
        "Account/HasInitialAccountMailValidated",
        {
          AccountID: context.$store.getters.accountID
        },
        this,
        function(data) {
          context.isMailValidated = data.ResponseVM.IsMailValidated;

          if (context.isMailValidated == false) {
            return;
          }

          context.$store.dispatch("AccountWithMailVerify", true);

          context.$router.push("dashboard");
        }
      );
    },
    validateAccountMail() {
      let context = this;

      if (context.model.email.trim() == "") {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Debe ingresar un email",
          context
        );
        return;
      }

      let req = {
        AccountID: context.$store.getters.accountID,
        Email: context.model.email,
        IsNewAccount: true
      };

      axiosHelpers.axiosPost("Account/ValidateAccountMail", req, this, function(
        data
      ) {
        if (data.ResponseVM.IsMailVerify) {
          notificationHelpers.showSuccess(
            "Exito",
            "Hemos enviado un correo para verificar tu cuenta. Seguí las instrucciones del mismo. Si ya lo verificaste, hace click al botón 'Ya lo Validé'.",
            context
          );
        }
      });
    },
    GetAccountMailForValidation() {
      let context = this;

      axiosHelpers.axiosPost(
        "Account/GetAccountMailForValidation",
        {
          AccountID: context.$store.getters.accountID
        },
        this,
        function(data) {
          context.cargado = true;
          if (data.ResponseVM.Email != null && data.ResponseVM.Email != "") {
            context.model.email = data.ResponseVM.Email;

            context.validateAccountMail();
          }
        }
      );
    }
  },
  beforeMount() {
    let context = this;

    context.ShouldPerformTwoStepVerification =
      context.$store.getters.ShouldPerformTwoStepVerification;

    context.GetAccountMailForValidation();
  }
};
</script>

<style lang="scss">
.email-validation-form {
  a {
    color: #ff4940;
  }

  a:hover {
    color: #c93961;
  }

  .rscolor {
    color: #ff4940;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    color: #ff4940;
  }

  .btn-cerrar-sesion {
    border-color: #f5365c;
    color: #f5365c;
    font-weight: 100;
  }

  .btnVerify {
    background: rgba(255, 88, 85, 1);
    padding: 10px;
    border-radius: 5px;
    color: #fff;
    text-decoration: none;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .btnVerify:hover {
    background: rgba(201, 57, 98, 1);
    color: #fff;
    text-decoration: none;
  }
}
</style>